import { render, staticRenderFns } from "./ShapeList.vue?vue&type=template&id=a169cbb0&"
import script from "./ShapeList.vue?vue&type=script&lang=js&"
export * from "./ShapeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports